export default __webpack_public_path__ + "static/media/logoAurea3.a0e39b81.png";